import { useEffect, useRef } from 'react';
import { VersionName, VersionedSnippet } from '@cld/code-snippet-next';
import { OnSnippetChange, OnTabChange, SnippetLanguage } from '../types';

export const useActiveSnippetChange = (
  activeSnippet: VersionedSnippet,
  onSnippetChange?: OnSnippetChange,
  onTabChange?: OnTabChange,
  language?: SnippetLanguage,
  version?: VersionName
) => {
  const initialRender = useRef(true);
  const initialTabsRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      onSnippetChange?.(activeSnippet);
    }
  }, [activeSnippet, language, onSnippetChange, version]);

  useEffect(() => {
    if (initialTabsRender.current) {
      initialTabsRender.current = false;
    } else {
      onTabChange?.(language);
    }
  }, [language]);
};
